var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9909 5.52C18.9909 8.4928 16.2475 12 12.0965 12H8.09813L7.90187 13.2384L6.96907 19.2H2L4.98933 0H13.04C15.7509 0 17.8837 1.51093 18.6693 3.61067C18.8959 4.22116 19.005 4.86898 18.9909 5.52Z",
    fill: "#002991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8555 11.04C21.5903 12.6514 20.7603 14.1159 19.514 15.1712C18.2677 16.2266 16.6865 16.804 15.0534 16.8H12.2768L11.1211 24H6.17871L6.96964 19.2L7.90298 13.2384L8.09871 12H12.0971C16.2427 12 18.9915 8.49282 18.9915 5.52002C21.0315 6.57282 22.2208 8.70029 21.8555 11.04Z",
    fill: "#60CDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9914 5.52005C18.136 5.07258 17.0986 4.80005 15.9696 4.80005H9.22823L8.09863 12H12.097C16.2426 12 18.9914 8.49285 18.9914 5.52005Z",
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalLogo);
export default __webpack_public_path__ + "static/media/paypal-logo.39c1c36c781293f6a19264c2a15519fa.svg";
export { ForwardRef as ReactComponent };